module.exports = __webpack_public_path__ + "static/media/icon_video_zoomin_bk.2d495e28.svg";